import React, {useContext, useRef, useState} from 'react';

// kendo react
import {NumericTextBox} from '@progress/kendo-react-inputs';
import {useLocalization} from "@progress/kendo-react-intl";
import {
    mainMessages,
    minQuantityKey,
    minQuantityMessageKey, minQuantityRequiredKey, qtyKey,
} from "../../../assets/text/MultilingualText";
import KSMPopover from "../../common/Popovers";
import UserContext from "../../common/UserContext";

//Custom cell and logic for Qty
export const SelectedQtyCell = (props) => {
    const {
        siteLanguageDefault
    } = useContext(UserContext);

    const localization = useLocalization();

    const field = props.field;
    const dataValue = props.dataItem[field];

    const anchor = useRef(null);
    const [popoverShow, setPopoverShow] = useState(false);

    // show popover if there is an error on mouse over
    const onMouseOver = (ev) => {
        if (isError) setPopoverShow(true);
    };

    // remove popover on mouse leave
    const onMouseOut = (ev) => {
        let isChildEl = ev.currentTarget.contains(ev.relatedTarget);
        if (!isChildEl) setPopoverShow(false);
    };

    let style = {}

    //Show error handling when assign qty is less than min qty
    let minQty = props.dataItem['saved_assigned_quantity'] > 1 ? props.dataItem['saved_assigned_quantity'] : 1;
    let isError = !props.dataItem['qty_valid']

    //Outline border as red
    if (isError) {
        style = {
            borderColor: 'var(--color-alert-danger-base)',
        }
    }

    //bound input events and values to the Grid
    const onChange = (ev) => {
        if (props.onChange) {
            props.onChange({
                dataIndex: 0,
                dataItem: props.dataItem,
                field: props.field,
                syntheticEvent: ev.syntheticEvent,
                value: ev.target.value,
            });
        }
    };

    return (
        <td ref={anchor} onMouseOver={onMouseOver} onMouseOut={onMouseOut}>
            <KSMPopover
                show={popoverShow}
                anchor={anchor.current}
                position={'top'}
                type={'error'}
                message={
                    <div>
                        <b style={{fontWeight: '600'}}>{localization.toLanguageString(minQuantityRequiredKey, mainMessages[siteLanguageDefault][minQuantityRequiredKey])}</b>
                        <br/>
                        {localization.toLanguageString(minQuantityMessageKey, mainMessages[siteLanguageDefault][minQuantityMessageKey])}
                        <br/>
                        {localization.toLanguageString(minQuantityKey, mainMessages[siteLanguageDefault][minQuantityKey])}: {minQty}
                    </div>
                }
            />
            <NumericTextBox
                className={'ksm-grid-numeric-input'}
                style={style}
                onChange={onChange}
                value={dataValue}
                spinners={false}
                min={1}
                format={{
                    useGrouping: false,
                }}
            />
        </td>
    );
};